import { generateBFFUrl, PROFILE_DATA_API } from '@/configs/apiEndPoints';
import axiosInstance from './axiosConfig';
import generateHttpHeaders from './axiosConfig/generateHttpHeaders';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { D365_USER_ID } from '@/constants/profileManagement';
import { GET_PROFILE_V2 } from '@/configs/ecom/apis';
import { ERROR } from '@/configs/constants';
import dlv from 'dlv';
import Cookies from '@/utils/cookie';

export const fetchProfile = async (serverCookie?: any): Promise<BFFCustomerProfileResponse> => {
  const profileData = await axiosInstance
    .get(generateBFFUrl(PROFILE_DATA_API), {
      headers: generateHttpHeaders(serverCookie),
    })
    .then(({ data }) => {
      return data;
    })
    .catch((error) => {
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
  return profileData;
};

export const getProfileV2 = async (serverCookie?: string): Promise<any> => {
  const d365UserId = Cookies.get(D365_USER_ID) ?? '';
  try {
    const res = await axiosInstance.get(generateBFFUrl(GET_PROFILE_V2), {
      params: {
        d365UserId,
      },
      headers: generateHttpHeaders(serverCookie),
    });
    const data = dlv(res, 'data.data', {});
    const { firstName, lastName, webEngageId, contacts, customerId } = data;

    // Transforming profile here to support old profile response

    const primaryMobileNumber = contacts?.find(
      (contact: any) => contact && contact.isPrimary && contact.phone,
    )?.phone;

    const profile = {
      ...data,
      name: firstName ? `${firstName}${firstName ? ` ${lastName ?? ''}` : ''}` : '',
      customer_code: customerId,
      primary_mobile_number: primaryMobileNumber,
      hashed_mobile_number: webEngageId,
      isLoggedIn: Boolean(primaryMobileNumber),
    };
    return profile;
  } catch (error: any) {
    const { response } = error;
    const { data, status, statusText } = response as AxiosResponse;
    throw new GenericError(ERROR.GENERIC_MESSAGE, status, statusText, data);
  }
};
